exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".baseContent {\n  height: 100%;\n  min-width: 1200px;\n}\n", ""]);

// exports
